import { render, staticRenderFns } from "./deals.vue?vue&type=template&id=0da37efa"
import script from "./deals.vue?vue&type=script&lang=js"
export * from "./deals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports